import { render } from "./InteractiveMenuItemView.vue?vue&type=template&id=5b124abf&scoped=true"
import script from "./InteractiveMenuItemView.vue?vue&type=script&lang=js"
export * from "./InteractiveMenuItemView.vue?vue&type=script&lang=js"

import "./InteractiveMenuItemView.vue?vue&type=style&index=0&id=5b124abf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b124abf"]])

export default __exports__